import { ContentType, RequestType } from '../Contract';
var RequestConfig = (function () {
    function RequestConfig(theRequestType, theIncludeDirty, theContentType) {
        this.requestType = (theRequestType !== undefined) ? theRequestType : RequestType.ModelRequest;
        this.contentType = (theContentType !== undefined) ? theContentType : ContentType.applicationJson;
        if (theIncludeDirty !== undefined) {
            this.includeDirty = theIncludeDirty;
        }
        else {
            if (this.requestType === RequestType.ModelRequest) {
                this.includeDirty = true;
            }
            else {
                this.includeDirty = false;
            }
        }
        this.headers = {};
    }
    return RequestConfig;
}());
export { RequestConfig };
